import React, { useState } from "react"
import { Link } from "gatsby"
import styled, { keyframes } from "styled-components"
import Img from "../../gatsbyImage/gatsbyImage"
const menuDatas = [
  { id: "1", name: `Article`, url: `/article` },
  { id: "2", name: `Category`, url: `/category` },
  { id: "3", name: `About`, url: `/about` },
]
import {
  animationGoAhead,
  animationRotate360R,
  animationRotate360L,
} from "./navbar.animation"
import { device } from "../../mediaQuery/mediaQuery"

const HeaderTest = ({ siteTitle }) => {
  const [menuOpen, setMenuOpen] = useState(false)

  return (
    <Nav>
      <LogoArea to="/">
        <Logo menuOpen={menuOpen}>
          <Img filename={`boren_logo.png`} alt="LOGO圖片" />
        </Logo>
        <Title>{siteTitle}</Title>
      </LogoArea>
      <Burger onClick={() => setMenuOpen(!menuOpen)}>
        <BurgerBar menuOpen={menuOpen} />
        <BurgerBar menuOpen={menuOpen} />
        <BurgerBar menuOpen={menuOpen} />
      </Burger>
      <MainMenus menuOpen={menuOpen}>
        {menuDatas.map(({ id, url, name }) => {
          return (
            <Menu key={id}>
              <MenuLink
                to={url}
                // partiallyActive={true}
                activeStyle={{ color: "gold" }}
              >
                {name}
              </MenuLink>
              {/* <MenuBar></MenuBar> */}
            </Menu>
          )
        })}
      </MainMenus>
    </Nav>
  )
}

const Nav = styled.nav`
  width: 100%;
  height: 100px;
  background-color: #071f35;
  margin: 0 auto 50px auto;
  padding: 20px 40px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const LogoArea = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  position: relative;
  z-index: 11;
`
const Logo = styled.div`
  margin-right: 15px;
  width: 48px;
  height: 48px;
  @media ${device.tablet} {
    transform-origin: center;
    ${({ menuOpen }) => (menuOpen ? animationRotate360R : animationRotate360L)};
    border-radius: ${({ menuOpen }) => (menuOpen ? `50%` : `10%`)};
    transition: border-radius 0.3s;
    overflow: hidden;
  }
`
const Title = styled.h1`
  font-size: 36px;
  font-weight: bold;
  color: white;
  @media ${device.tablet} {
    display: none;
  }
`
const Burger = styled.div`
  @media ${device.tablet} {
    width: 32px;
    height: 32px;
    position: flxed;
    top: 15px;
    right: 20px;
    display: flex;
    justify-content: space-around;
    flex-flow: column nowrap;
    cursor: pointer;
    z-index: 11;
  }
`
const BurgerBar = styled.div`
  @media ${device.tablet} {
    width: 100%;
    height: 3px;
    background-color: white;
    border-radius: 2px;
    transform-origin: 1px;
    transition: all 0.3s linear;
    :nth-child(1) {
      transform: ${({ menuOpen }) =>
        menuOpen ? "rotate(45deg)" : "rotate(0)"};
    }
    :nth-child(2) {
      transform: ${({ menuOpen }) =>
        menuOpen ? "translateX(100%)" : "translateX(0)"};
      opacity: ${({ menuOpen }) => (menuOpen ? "0" : "1")};
    }

    :nth-child(3) {
      transform: ${({ menuOpen }) =>
        menuOpen ? "rotate(-45deg)" : "rotate(0)"};
    }
  }
`

const MainMenus = styled.ul`
  display: flex;
  flex-flow: row nowrap;

  @media ${device.tablet} {
    flex-flow: column nowrap;
    top: 0;
    left: 0;
    height: 100vh;
    padding: 10px;
    padding-top: 100px;
    width: 100vw;
    box-sizing: border-box;
    position: fixed;
    z-index: 10;
    background-color: #071f35;
    transform: ${({ menuOpen }) =>
      menuOpen ? "translateX(0)" : "translateX(-100%)"};
    transition: transform 0.3s ease-in-out;
  }
`

const Menu = styled.li`
  list-style: none;
  font-size: 28px;
  position: relative;
  :not(:last-child) {
    margin-right: 30px;
  }
  @media ${device.tablet} {
    color: white;
    margin: 0;
    text-align: center;
    :not(:last-child) {
      margin: 0;
    }
  }
`
const MenuLink = styled(Link)`
  text-decoration: none;
  color: white;
  font-weight: bold;
  padding-bottom: 6px;
  display: block;

  :after {
    content: "";
    position: absolute;
    top: 100%;
    width: 0px;
    height: 6px;
    left: 0;
    right: 0;
    margin: auto;
    background-color: #f7f7f7;
    border-radius: 3px;
  }
  /* &:hover {
    color: gold;
  } */
  &:hover {
    &::after {
      ${animationGoAhead}
    }
  }
`

export default HeaderTest
